import axios from "axios";

export const APIURL = process.env.REACT_APP_API_ENDPOINT;
export const SUBSCRIPTIONS_URL = APIURL+"/subscriptions";

// READ
export function getAllSubscriptions() {
  return axios.get(SUBSCRIPTIONS_URL);
}

// Method from server should return QueryResultsModel(items: any[], totalsCount: number)
// items => filtered/sorted result
export function findSubscriptions(queryParams) {
  const result = axios.post(`${SUBSCRIPTIONS_URL}/find`, { queryParams });
  return result;
}
